import React, { useState, useRef } from 'react';
import { graphql, Link } from 'gatsby';
import LitImage from './images/LitImage';
import LitStructuredText from './generic/LitStructuredText';
import Modal from './Modal';
const ModularButtonVideo = ({ data }) => {
  const [dialogShow, setDialogShow] = useState(true);
  const [animation, setAnimation] = useState(false);
  const modal = useRef(null);
  const video = useRef(null);

  const switchDialog = () => {
    const videoPause = video.current;
    const dialog = modal.current;
    setDialogShow((prevState) => !prevState);
    if (dialogShow) {
      dialog.showModal();
      setAnimation('open-modal');
      videoPause.play();
    } else if (!dialogShow) {
      videoPause.pause();
      setAnimation('close-modal');
      setTimeout(() => {
        dialog.close();
      }, 200);
      videoPause.currentTime = 0;
    }
  };
  const {
    buttonText,
    backgroundColour,
    copy,
    heading,
    buttonMedia,
    image,
    noText,
  } = data;
  return (
    <div
      className={`modular-button-video-container ${backgroundColour} modular-padding-large`}
    >
      <div className="modular-button-video-inner modular-global-width modular-text-center">
        {!noText && (
          <>
            {heading?.value ? (
              <LitStructuredText data={heading} basic />
            ) : (
              heading
            )}
            <div className="modular-button-video-image">
              <LitImage image={image} alt="yellow device illustrations" />
            </div>
            {copy?.value ? (
              <div className="modular-p">
                <LitStructuredText data={copy} basic />
              </div>
            ) : (
              <div className="modular-p">{copy}</div>
            )}
          </>
        )}
        <button onClick={switchDialog}>{buttonText}</button>
      </div>

      <Modal
        animation={animation}
        dialogShow={dialogShow}
        modal={modal}
        switchDialog={switchDialog}
        transparent={true}
      >
        <video controls ref={video} className={animation} loop>
          <source src={buttonMedia.url} type="video/mp4" />
        </video>
      </Modal>
    </div>
  );
};

export default ModularButtonVideo;
export const fragment = graphql`
  fragment ModularButtonVideo on DatoCmsHeadingBodyImageVideoButton {
    internal {
      type
    }
    id
    buttonText
    backgroundColour
    noText
    copy {
      value
    }
    heading {
      value
    }
    buttonMedia {
      url
    }
    image {
      gatsbyImageData
    }
  }
`;
